import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FunnyLoaderService } from '../../services/funny-loader.service';
import { Subject, takeUntil } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-funny-loader',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      *ngIf="isVisible"
      class="funny-loader fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center"
      [@fadeInOut]
    >
      <div class="animate-bounce text-3xl mb-4">🐄</div>
      <div class="animate-spin rounded-full border-b-2 border-primary-600 h-12 w-12 mb-4"></div>
      <div class="text-xl font-medium text-slate-800">{{ currentText }}</div>
    </div>
  `,
  styles: [`
    :host {
      display: contents;
    }
    .funny-loader {
     z-index: 10000;
    }
  `],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        animate('300ms', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class FunnyLoaderComponent implements OnInit, OnDestroy {
  isVisible = false;
  currentText = '';
  private destroy$ = new Subject<void>();

  constructor(private funnyLoaderService: FunnyLoaderService) {}

  ngOnInit(): void {
    this.funnyLoaderService.isVisible$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isVisible => {
        this.isVisible = isVisible;
      });

    this.funnyLoaderService.currentText$
      .pipe(takeUntil(this.destroy$))
      .subscribe(text => {
        this.currentText = text;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
